


import { useEffect, useState } from 'react'
import Loader from '../components/loader'
import { errorMessage } from '../utils/utils';
import { CiCircleCheck } from 'react-icons/ci';
import { PiWarningCircleThin } from 'react-icons/pi';
import { Bounce, toast, ToastContainer } from 'react-toastify';
import Spinner from '../components/spinner';
import { FaRegEye, FaRegEyeSlash } from 'react-icons/fa';
import api from '../utils/api';
import AuthShell, { authButton, authInput, authLabel, authLink } from '../components/AuthShell';

export default function PageIndex() {

    const [error, setError] = useState('');
    const [success, setSuccess] = useState('');

    const [loading, setLoading] = useState(false);

    const [isVerify, setIsVerify] = useState(false);
    const [isReset, setIsReset] = useState(false);

    const [password, setPassword] = useState('');
    const [showPass, setShowPass] = useState(false);


    useEffect(() => {

        const params = new URLSearchParams(window.location.search);

        const reset = params.get('reset');
        if (reset) {
            verifyReset(reset);
            return;
        }

        const verify = params.get('verify');
        if (verify) {
            verifyToken(verify);
            return;
        }

        const token = window.localStorage.token;

        if (token) {
            if (window.location.pathname === '/') {
                window.location.replace(`/dashboard${window.location.search}`);
            }

        } else {
            window.location.replace(`/signin${window.location.search}`);
        }

    }, []);


    function goToPage(url: string) {
        window.localStorage.removeItem('refresh');
        window.localStorage.removeItem('token');
        window.localStorage.removeItem('email');
        window.localStorage.removeItem('name');
        window.localStorage.removeItem('id');
        window.location.replace(url);
    }


    async function verifyToken(token: string) {

        try {
            const res = await api.post(`/auth/verify/${token}`);
            const json = await res.json();

            if (res.ok) {
                setSuccess(json.message);
            } else {
                setError(errorMessage(json));
            }

        } catch (err) {
            setError(errorMessage(err));
        }

        setIsVerify(true);
    }

    async function verifyReset(token: string) {

        try {
            const res = await api.post(`/auth/verify/${token}`);
            const json = await res.json();

            if (res.ok) {
                if (json.ok === true) {
                    setError('');
                    setIsReset(true);
                    return;
                } else {
                    setError('Server Error. Plese contact <b><a href="mailto:support@kptd.ph">support@kptd.ph</a></b>');
                }
            } else {
                setError(errorMessage(json));
            }

        } catch (err) {
            setError(errorMessage(err));
        }

        setIsVerify(true);
    }

    async function updatePassword(e: any) {
        e.preventDefault();
        setShowPass(false);
        setError('');
        setLoading(true);

        try {

            const params = new URLSearchParams(window.location.search);
            const token = params.get('reset');

            const res = await api.patch(`/user/password/reset`, { password, token });

            const json = await res.json();
            if (res.ok) {
                toast.success(json.message);
            } else {
                setError(errorMessage(json));
            }
        } catch (err) {
            setError(errorMessage(err));
        }
        setLoading(false);
    }

    if (isReset) {
        return (
            <>
                <AuthShell
                    title="Create a new password"
                    subtitle="Choose a strong password you haven't used before."
                    footer={<>
                        <div className="text-slate-500">
                            Finished? <a href="/signin" className={authLink}>Sign In</a>
                        </div>
                        <a href="/" className="font-semibold text-slate-500 transition hover:text-slate-900">Go back to home</a>
                    </>}>

                    <form onSubmit={updatePassword}>

                        <div className="mb-5">
                            <label htmlFor="password" className={authLabel}>New password</label>
                            <div className="relative mt-1.5">
                                <input
                                    id="password"
                                    name="password"
                                    type={showPass ? 'text' : "password"}
                                    required
                                    value={password}
                                    disabled={loading}
                                    placeholder="Enter new password"
                                    autoComplete="new-password"
                                    className={`${authInput} pr-11`}
                                    onChange={(e) => setPassword(e.target.value)}
                                />
                                <button
                                    type="button"
                                    aria-label={showPass ? 'Hide password' : 'Show password'}
                                    className="absolute inset-y-0 end-0 flex items-center px-3 text-slate-400 transition hover:text-slate-600"
                                    onClick={loading ? undefined : () => setShowPass(!showPass)}>
                                    {showPass ? <FaRegEye className="text-emerald-600" /> : <FaRegEyeSlash />}
                                </button>
                            </div>
                        </div>

                        {error && (
                            <div className="mb-5 rounded-xl bg-red-50 px-4 py-3 text-center text-sm font-medium text-red-700 ring-1 ring-red-100">
                                <div dangerouslySetInnerHTML={{ __html: error }} />
                            </div>
                        )}

                        <button type="submit" disabled={loading} className={authButton}>
                            {loading && <Spinner className="w-4 h-4" />} Change password
                        </button>

                    </form>

                </AuthShell>

                <ToastContainer
                    position="bottom-right"
                    autoClose={5000}
                    hideProgressBar={false}
                    newestOnTop={false}
                    closeOnClick={true}
                    rtl={false}
                    pauseOnFocusLoss
                    draggable
                    pauseOnHover
                    theme="light"
                    transition={Bounce}
                />
            </>
        )
    }

    if (isVerify) {
        return (
            <AuthShell
                footer={<>
                    <button onClick={() => goToPage('/signin')} className={`cursor-pointer ${authLink}`}>Sign In</button>
                    <button onClick={() => goToPage('/')} className="font-semibold text-slate-500 transition hover:text-slate-900">Go back to home</button>
                </>}>

                <div className="text-center">

                    {error && <>
                        <div className="mx-auto flex h-20 w-20 items-center justify-center rounded-3xl bg-red-50 ring-1 ring-red-100">
                            <PiWarningCircleThin size={48} className="text-red-500" />
                        </div>
                        <div className="mt-5 text-sm leading-relaxed text-red-600" dangerouslySetInnerHTML={{ __html: error }} />
                    </>}

                    {success && <>
                        <div className="mx-auto flex h-20 w-20 items-center justify-center rounded-3xl bg-emerald-50 ring-1 ring-emerald-100">
                            <CiCircleCheck size={48} className="text-emerald-500" />
                        </div>
                        <div className="mt-5 text-sm leading-relaxed text-slate-600" dangerouslySetInnerHTML={{ __html: success }} />
                    </>}

                </div>

            </AuthShell>
        )
    }

    return (<div className='flex min-h-screen min-h-[100dvh] flex-col items-center justify-center bg-gradient-to-br from-slate-900 via-blue-950 to-slate-900'><Loader className='w-[50px] h-[50px]' /></div>);


}
